import useGoToPurchase from './useGoToPurchase';

export default useGoToPurchase;
